"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPartnerProducts = exports.getPartnerCatalogProducts = void 0;
const limit_1 = require("../../limit");
const routes_1 = require("../../routes");
const getPartnerCatalogProducts = (client) => async (params, query) => {
    if (query?._id || query?.assortment_partner_product_ids || query?.invivo_ids) {
        return getPartnerProductByIds(client, params, query);
    }
    if (!query?.page && !query?.limit) {
        return (0, exports.getAllPartnerProducts)(client)(params, query);
    }
    if (query?.limit && !query?.page) {
        return getAllPartnerProductsByLimit(client, params, query);
    }
    return getPartnerProductByIds(client, params, query);
};
exports.getPartnerCatalogProducts = getPartnerCatalogProducts;
async function getPartnerProductByIds(client, params, query) {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_PARTNER_CATALOG_PRODUCTS.applyParams(params), {
        params: {
            ...query,
            _id: query?._id?.join(','),
            assortment_partner_product_ids: query?.assortment_partner_product_ids?.join(','),
            invivo_ids: query?.invivo_ids?.join(','),
        },
    });
    return response.data;
}
async function getAllPartnerProductsByLimit(client, params, query) {
    return (0, limit_1.getByLimit)(client, routes_1.ENDPOINTS.GET_ALL_PARTNER_CATALOG_PRODUCTS.applyParams(params), {
        ...query,
        _id: query?._id?.join(','),
        assortment_partner_product_ids: query?.assortment_partner_product_ids?.join(','),
        invivo_ids: query?.invivo_ids?.join(','),
    });
}
const getAllPartnerProducts = (client) => async (params, query) => {
    let result = [];
    let page = 1;
    let hasMoreData = true;
    while (hasMoreData) {
        try {
            const response = await client.get(routes_1.ENDPOINTS.GET_ALL_PARTNER_CATALOG_PRODUCTS.applyParams(params), {
                params: {
                    ...query,
                    page,
                    limit: 100,
                    _id: query?._id?.join(','),
                    assortment_partner_product_ids: query?.assortment_partner_product_ids?.join(','),
                    invivo_ids: query?.invivo_ids?.join(','),
                },
            });
            const { data } = response;
            if (Array.isArray(data) && data.length > 0) {
                result = result.concat(data);
                page++;
            }
            else {
                hasMoreData = false;
            }
        }
        catch (error) {
            throw new Error(`Error retrieving data on page ${page} caused by ${error.message}`);
        }
    }
    return result;
};
exports.getAllPartnerProducts = getAllPartnerProducts;
